import M from "./ghl-ui.es1636.js";
import p from "./ghl-ui.es1634.js";
import x from "./ghl-ui.es1546.js";
import H from "./ghl-ui.es1643.js";
var v = 36e5, c = 6e4, _ = 2, i = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: H
};
function j(t, r) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (t === null)
    return /* @__PURE__ */ new Date(NaN);
  var e = r || {}, a = e.additionalDigits == null ? _ : M(e.additionalDigits);
  if (a !== 2 && a !== 1 && a !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]")
    return new Date(t.getTime());
  if (typeof t == "number" || Object.prototype.toString.call(t) === "[object Number]")
    return new Date(t);
  if (!(typeof t == "string" || Object.prototype.toString.call(t) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var n = $(t), l = b(n.date, a), u = l.year, o = l.restDateString, f = U(o, u);
  if (isNaN(f))
    return /* @__PURE__ */ new Date(NaN);
  if (f) {
    var Y = f.getTime(), D = 0, s;
    if (n.time && (D = m(n.time), isNaN(D)))
      return /* @__PURE__ */ new Date(NaN);
    if (n.timeZone || e.timeZone) {
      if (s = x(n.timeZone || e.timeZone, new Date(Y + D)), isNaN(s))
        return /* @__PURE__ */ new Date(NaN);
    } else
      s = p(new Date(Y + D)), s = p(new Date(Y + D + s));
    return new Date(Y + D + s);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function $(t) {
  var r = {}, e = i.dateTimePattern.exec(t), a;
  if (e ? (r.date = e[1], a = e[3]) : (e = i.datePattern.exec(t), e ? (r.date = e[1], a = e[2]) : (r.date = null, a = t)), a) {
    var n = i.timeZone.exec(a);
    n ? (r.time = a.replace(n[1], ""), r.timeZone = n[1].trim()) : r.time = a;
  }
  return r;
}
function b(t, r) {
  var e = i.YYY[r], a = i.YYYYY[r], n;
  if (n = i.YYYY.exec(t) || a.exec(t), n) {
    var l = n[1];
    return {
      year: parseInt(l, 10),
      restDateString: t.slice(l.length)
    };
  }
  if (n = i.YY.exec(t) || e.exec(t), n) {
    var u = n[1];
    return {
      year: parseInt(u, 10) * 100,
      restDateString: t.slice(u.length)
    };
  }
  return {
    year: null
  };
}
function U(t, r) {
  if (r === null)
    return null;
  var e, a, n, l;
  if (t.length === 0)
    return a = /* @__PURE__ */ new Date(0), a.setUTCFullYear(r), a;
  if (e = i.MM.exec(t), e)
    return a = /* @__PURE__ */ new Date(0), n = parseInt(e[1], 10) - 1, I(r, n) ? (a.setUTCFullYear(r, n), a) : /* @__PURE__ */ new Date(NaN);
  if (e = i.DDD.exec(t), e) {
    a = /* @__PURE__ */ new Date(0);
    var u = parseInt(e[1], 10);
    return F(r, u) ? (a.setUTCFullYear(r, 0, u), a) : /* @__PURE__ */ new Date(NaN);
  }
  if (e = i.MMDD.exec(t), e) {
    a = /* @__PURE__ */ new Date(0), n = parseInt(e[1], 10) - 1;
    var o = parseInt(e[2], 10);
    return I(r, n, o) ? (a.setUTCFullYear(r, n, o), a) : /* @__PURE__ */ new Date(NaN);
  }
  if (e = i.Www.exec(t), e)
    return l = parseInt(e[1], 10) - 1, d(r, l) ? w(r, l) : /* @__PURE__ */ new Date(NaN);
  if (e = i.WwwD.exec(t), e) {
    l = parseInt(e[1], 10) - 1;
    var f = parseInt(e[2], 10) - 1;
    return d(r, l, f) ? w(r, l, f) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function m(t) {
  var r, e, a;
  if (r = i.HH.exec(t), r)
    return e = parseFloat(r[1].replace(",", ".")), N(e) ? e % 24 * v : NaN;
  if (r = i.HHMM.exec(t), r)
    return e = parseInt(r[1], 10), a = parseFloat(r[2].replace(",", ".")), N(e, a) ? e % 24 * v + a * c : NaN;
  if (r = i.HHMMSS.exec(t), r) {
    e = parseInt(r[1], 10), a = parseInt(r[2], 10);
    var n = parseFloat(r[3].replace(",", "."));
    return N(e, a, n) ? e % 24 * v + a * c + n * 1e3 : NaN;
  }
  return null;
}
function w(t, r, e) {
  r = r || 0, e = e || 0;
  var a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(t, 0, 4);
  var n = a.getUTCDay() || 7, l = r * 7 + e + 1 - n;
  return a.setUTCDate(a.getUTCDate() + l), a;
}
var C = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], O = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function T(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function I(t, r, e) {
  if (r < 0 || r > 11)
    return !1;
  if (e != null) {
    if (e < 1)
      return !1;
    var a = T(t);
    if (a && e > O[r] || !a && e > C[r])
      return !1;
  }
  return !0;
}
function F(t, r) {
  if (r < 1)
    return !1;
  var e = T(t);
  return !(e && r > 366 || !e && r > 365);
}
function d(t, r, e) {
  return !(r < 0 || r > 52 || e != null && (e < 0 || e > 6));
}
function N(t, r, e) {
  return !(t != null && (t < 0 || t >= 25) || r != null && (r < 0 || r >= 60) || e != null && (e < 0 || e >= 60));
}
export {
  j as default
};
